import { gql } from "lib/apolloClient";
import { LtiFragment } from "./LTIFragments";

export const getLtiLaunchData = gql`
  query getLtiLaunchDataQuery($launchInput: LTILaunchInput!, $ids: [ID!]) {
    platform {
      user(ids: $ids) {
        ... on Staff {
          ltiLaunchData(launchInput: $launchInput) {
            ...ltiFragment
          }
        }
        ... on Student {
          ltiLaunchData(launchInput: $launchInput) {
            ...ltiFragment
          }
        }
        ... on FamilyMember {
          ltiLaunchData(launchInput: $launchInput) {
            ...ltiFragment
          }
        }
      }
    }
  }
  ${LtiFragment.ltiFragment}
`;

export const getLTIServicesForCurriculumQuery = gql`
  query getLTIIntegrationsCreds(
    $input: LTIIntegrationsCredsQueryInput!
    $includeMetadata: Boolean = false
  ) {
    integration {
      getLTIIntegrationsCreds(input: $input) {
        id
        entityType
        entityId
        serviceName
        name
        metadata @include(if: $includeMetadata)
      }
    }
  }
`;
